import React from 'react';
import { X, Smartphone, Star, Check } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';
import { PairUpLogo } from './common/PairUpLogo';

interface AppDownloadModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AppDownloadModal: React.FC<AppDownloadModalProps> = ({ isOpen, onClose }) => {
  const [copied, setCopied] = React.useState(false);
  const appDownloadUrl = window.location.origin;

  const handleCopyLink = () => {
    navigator.clipboard?.writeText(appDownloadUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-slate-950/75 backdrop-blur-xs flex items-center justify-center p-4 animate-in fade-in">
      <div className="relative bg-white rounded-3xl max-w-sm w-full overflow-hidden shadow-2xl border border-pink-100 p-6 text-center">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-600 transition-colors cursor-pointer"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="flex justify-center mb-3">
          <PairUpLogo className="w-32 h-32" />
        </div>

        <h3 className="text-xl font-extrabold text-slate-900">Get PairUpToday App</h3>
        <p className="text-xs text-slate-500 mt-1 mb-4">
          Scan QR code with your phone camera to download directly for iOS & Android
        </p>

        {/* Real Dynamic QR Code */}
        <div className="p-4 bg-slate-50 rounded-2xl border border-slate-200 inline-block mb-3">
          <div className="bg-white p-3 rounded-xl shadow-xs flex flex-col items-center justify-center">
            <QRCodeSVG
              value={appDownloadUrl}
              size={168}
              level="H"
              includeMargin={false}
              imageSettings={{
                src: '/assets/image_AIIEuv.png',
                x: undefined,
                y: undefined,
                height: 32,
                width: 32,
                excavate: true,
              }}
            />
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 text-xs text-slate-600 font-semibold mb-3">
          <Star className="w-4 h-4 fill-amber-400 text-amber-400" />
          <span>4.9 / 5 on App Store & Google Play</span>
        </div>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={handleCopyLink}
            className="flex-1 py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-800 font-bold text-xs rounded-xl transition-colors cursor-pointer flex items-center justify-center gap-1.5"
          >
            {copied ? <Check className="w-3.5 h-3.5 text-emerald-600" /> : null}
            <span>{copied ? 'Link Copied!' : 'Copy App Link'}</span>
          </button>
          <button
            onClick={onClose}
            className="flex-1 py-2.5 bg-slate-900 text-white font-bold text-xs rounded-xl hover:bg-slate-800 transition-colors cursor-pointer"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
